<div class="rubii-progress">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<ng-container *ngIf="!forAuth">
    <router-outlet (deactivate)="deactivate()"></router-outlet>
</ng-container>

<div *ngIf="forAuth" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" style="height: 100%">
    <p>Authentication completed! Please leave this window open for a while. If it does not close automatically, you can close it</p>
</div>
